<script lang="ts" setup>
defineProps<{
  hasBorder?: boolean
  noDefaultMargin?: boolean
}>()
</script>

<template>
  <div :class="`${hasBorder ? 'pt-5 mt-5 border-t border-white/20' : noDefaultMargin !== true ? 'mt-10' : ''} mx-5`">
    <slot />
  </div>
</template>
